import { setAlert } from "./alert";
import { downloadExcel } from "../../helpers";
export const handleResponse = (response, config) => async dispatch => {
    try {
        // DESC: If the response has an alert
        if (response.data.hasOwnProperty("alert")) {
            let alert = response.data.alert;
            let isAnObject = typeof alert === "object";

            // DESC: The alert is either a string (msg) or object with more params
            let message = isAnObject ? alert.msg : alert;

            // DESC: The type is optional, otherwise determine based on status code
            let type =
                isAnObject && alert.hasOwnProperty("type") ?
                    alert.type :
                    response.status < 300 ?
                        "success" :
                        "error";

            let timeout =
                isAnObject && alert.hasOwnProperty("timeout") ?
                    alert.timeout :
                    type === "error" ?
                        false :
                        15000;
            dispatch(setAlert(message, type, timeout));
        }

        // DESC: If the response has a redirect
        if (response.data.hasOwnProperty("redirect_url")) {
            if (!response.data.redirect_url.startsWith("/app")) {
                // DESC: browserHistory doesn't work for non-react routes
                return window.location.replace(response.data.redirect_url);
            }
            window.location.replace(response.data.redirect_url);
        }
        if (response.headers["content-disposition"]) {
            let contents = response.headers["content-disposition"].split(";");
            let props = {};
            contents.forEach(content => (props[content] = true));
            //  Download attachment

            if (props.attachment) {
                downloadExcel(response.data, {
                    name: config.fileName,
                    type: config.extension
                });
            }
        }
        //  Show message if there is a x-message header
        if (response.headers["x-message"]) {
            let text = await response.data.text();

            try {
                text = JSON.parse(text);
                dispatch(setAlert(text.msg, "info"));
            }
            catch (error) {
                // eslint-disable-next-line no-undef
                consoleDebug({ error });
            }
        }
        return true;
    }
    catch (error) {
        console.debug("handleResponse error!", response, error);
        return false;
    }
};